<template>
  <v-app>

    <v-navigation-drawer dark app fixed permanent v-bind:width="350" >
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title">
            LeiKa-Schau
          </v-list-item-title>
          <v-list-item-subtitle>
            Stand der OZG Formulare
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list
        dense
        nav
      >

        <v-list-item
          v-for="item in allFimSchemas.edges"
          :key="item.node.id"
          link
          :to="{ name: 'form', params: { id: item.node.id }}"
        >
          <v-list-item-content>
            <v-list-item-title>{{ item.node.serviceFeature.name }} <OZGLevelEmoji :level="item.node.serviceFeature.implementationLevel" /></v-list-item-title>
          </v-list-item-content>
        </v-list-item>

      </v-list>
       <template v-slot:append>
         <div class="pa-2" style="color: white; text-align: center;">
           <p>OZG-Formulare von xDatenfelder zu <a href="https://json-schema.org/">JSON Schema Forms</a> konvertiert mit <a href="https://github.com/LilithWittmann/ozg/">ozg</a> von
             <a href="https://twitter.com/LilithWittmann">@LilithWittmann</a>.</p>
         </div>
       </template>
    </v-navigation-drawer>
    <v-main>
          <router-view />
    </v-main>

  </v-app>
</template>

<script>

  import OZGLevelEmoji from './components/OZGLevelEmoji';

export default {
  name: 'App',
  components: {OZGLevelEmoji},
    data () {
      return {
        allFimSchemas: {
          edges: []
        },
        right: null,
      }
    },

    apollo: {
    $client: "ozgClient",
    allFimSchemas: {
      query: require("./graphql/allFIMSchemas.gql"),

    },
  }
};
</script>
